export const APP_LISTING_HOME_LINK = '/';
